// extracted by mini-css-extract-plugin
module.exports = {"reviewsHeader":"header_reviewsHeader___2n5c","subtitle":"header_subtitle__3rwLR"};